<div class="acc-application-dialog-interview-part">
	<readonly-access [readonly]="form.accAppDialogDataService.isReadonly()"></readonly-access>

	<div class="d-flex flex-column mb-4">
		<h6>Score</h6>
		<p>{{scoreText()}}</p>
	</div>
	<div class="row">
		<div class="col-md-6">
			<div class="d-flex flex-column gap-4">
				<div class="d-flex flex-column">
					<h6>Value Proposition</h6>
					<p>What is uniquely valuable about your idea that will cause people to pay for it? How do you know
						they need it?</p>
					<common-select-field [field]="form.valueProposition()"></common-select-field>
				</div>
				<div class="d-flex flex-column">
					<h6>Profitability/Sustainability</h6>
					<p>How do you plan to make money with this idea to create a long-lasting business?</p>
					<common-select-field [field]="form.profitabilitySustainability()"></common-select-field>
				</div>
			</div>
		</div>
		<div class="col-md-6">
			<div class="d-flex flex-column gap-4">
				<div class="d-flex flex-column">
					<h6>Coachability</h6>
					<p>Tell me about the last time you disagreed with someone else in a business setting. What happened
						and what was the outcome?</p>
					<common-select-field [field]="form.coachability()"></common-select-field>
				</div>
				<div class="d-flex flex-column">
					<h6>Time/Passion/Commitment</h6>
					<p>Why this accelerator and why now? How will you balance it with other personal and professional
						commitments?</p>
					<common-select-field [field]="form.timeCommitment()"></common-select-field>
				</div>
			</div>
		</div>
	</div>
	<div class="d-flex flex-column">
		<h6>Intake Interview Narrative</h6>
		<p>Write a synopsis of your interview and your conclusions based on the conversation. This
			informational
			narrative includes
			general impressions of the entrepreneur, perceived coachability, possible challenges, and
			standout
			abilities.</p>
		<common-text-field [field]="form.notes()"></common-text-field>
	</div>
	@if(form.accApplicationInterview(); as accApplicationInterview){
	<div class="d-flex flex-column mt-3">
		<p>Updated By: {{accApplicationInterview.updatedByStaffName}} on {{getDate(accApplicationInterview.updatedUTC)}}
		</p>
	</div>
	}
	<div class="mt-3">
		<common-button-row [center]="true">
			<button #interviewSaveForm class="btn btn-standard" [disabled]="form.disableSaveBtn()">
				{{form.accApplicationInterview() ? 'Update' : 'Save'}} Interview
			</button>
			@if(form.accApplicationInterview()) {
			<button (click)="form.revertForm()" class="btn btn-standard" [disabled]="form.disableSaveBtn()">
				Revert Changes
			</button>
			}

		</common-button-row>
	</div>
</div>